import {useState, useEffect} from 'react';
import { initializeApp } from "firebase/app"
import { getFirestore } from "firebase/firestore"
import { doc, getDoc } from "firebase/firestore";

const config = {
    apiKey: "AIzaSyBk5G-rlgQgHdFVHMrz3uVhHhCRItEsI1c",
    authDomain: "ggs-bot-landing.firebaseapp.com",
    projectId: "ggs-bot-landing",
    storageBucket: "ggs-bot-landing.appspot.com",
    messagingSenderId: "76046164341",
    appId: "1:76046164341:web:c1e7f8904ba23f3ac8f33c"
};

export const firebaseApp = initializeApp(config);

async function load() {
    const db = getFirestore(firebaseApp);
    const docRef = doc(db, "bot_settings", "landing_menu");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const menuItems = docSnap.data();
      return menuItems;
    } else {
      return {};
    }
}


export default function useFirebase() {
    const [data, setData] = useState({});
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        load().then(items => {
            setData(items);
            setLoading(false);
        }).catch(e => {
            setLoading(false);
        })
    }, [])


    return [data, isLoading]
}